enum OrderDetailsRouteViewMode {
  ORDERED = "ORDERED",
  SOLVED = "SOLVED",
}

export default OrderDetailsRouteViewMode;
